import React from 'react'
import { connect } from 'react-redux'
import withApp from '@brainstud/react-tbl/core/provider/withApp'
import { scrollTop } from '@brainstud/react-helpers'
import { getNavigation } from '@brainstud/react-tbl/features/navigation'
import { withModal } from '@brainstud/react-tbl/features/modals'

class HomeView extends React.Component {
  componentDidMount() {
    this.props.app.setCurrentTheme(null)
    scrollTop()
  }

  render() {
    const HomeTemplate = this.props.app.templates.home

    return <HomeTemplate {...this.props} />
  }
}

export default withApp(withModal(connect(
  (state, props) => {
    const navigation = state.navigation.list.byId
    const navigationIds = state.navigation.list.allIds
    const chapters = state.chapters.chapters.byId
    const pages = state.pages.list.byId
    const user = state.account.user

    const nav = getNavigation(navigationIds, navigation, chapters, pages)
    const home = state.home

    return { home, nav, user }
  },
  () => ({}),
)(HomeView)))
